import React from 'react'
import { FormControlLabel, Radio, RadioGroup } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import useTestAttribute from '../hooks/useTestAttribute'

const useStyles = makeStyles(({ typography, palette }) => ({
  radio: {
    color: palette.grey.shade[30]
  },
  label: {
    color: palette.grey.shade[90],
    '& .MuiFormControlLabel-label': {
      ...typography.body.s
    }
  }
}))

const SimpleSelect = ({ options, value, onChange, ...props }) => {
  const classes = useStyles()
  const { 'data-test': dataTest = 'radio-group' } = props
  const testAttr = useTestAttribute(dataTest)

  return (
    <RadioGroup
      value={value}
      onChange={evt => onChange(evt.target.value)}
      {...props}
    >
      {options.map(({ label, value }, index) => (
        <FormControlLabel
          value={value}
          control={
            <Radio
              size='small'
              color='primary'
              className={classes.radio}
              inputProps={{ 'data-test': testAttr(index, 'input') }}
            />
          }
          key={value}
          label={<span data-test={testAttr(index, 'label')}>{label}</span>}
          classes={{ root: classes.label }}
        />
      ))}
    </RadioGroup>
  )
}

export default SimpleSelect
